module.exports = __webpack_public_path__ + "static/img/album02_0.635a9d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album02/album02_0.png
// module id = rdRR
// module chunks = 1